import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommentBadgeComponent } from '@lite-workspace/shared/blocks/comment-badge';
import type { NavItem } from './hlm-app-shell';

/** A tab's counter after its label — the desktop tab and every phone menu item render this one piece. */
@Component({
  selector: 'hlm-app-shell-count',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommentBadgeComponent],
  template: `
    @if (item().countStyle === 'comments') {
      <!-- A zero-width anchor at the label's end: the circle rides its top-right corner out of flow, so the
           label never shifts. The circle is aria-hidden; the sr-only text names the count once, on the desktop
           tab and in every phone menu alike («Чат, 3 нерешённых»). -->
      @if (item().count) {
        <span class="relative inline-block w-0 align-top"
          ><span class="absolute left-0 -top-1 ml-0.5" data-tab-count aria-hidden="true"
            ><app-comment-badge kind="count" tone="accent" [count]="item().count ?? 0" /></span
        ></span>
        <span class="sr-only">, {{ item().countLabel ?? item().count }}</span>
      }
    } @else if (item().count !== undefined) {
      @if (item().countTone === 'accent') {
        <span class="ml-1 rounded-full bg-acc px-1.5 text-2xs font-semibold text-on-acc">{{ item().count }}</span>
      } @else {
        <span class="ml-1 text-c3">{{ item().count }}</span>
      }
    }
  `,
  styles: `
    /* Without it the wrapper is a full text line with the circle sitting on its baseline, and -top-1
       lifts the line, not the circle: the circle stays at word height. The extra 2px up sets the circle
       just above the word's cap line, as on the approved mock. */
    [data-tab-count] {
      line-height: 0;
      margin-top: calc(var(--spacing) * -0.5);
    }
  `,
})
export class HlmAppShellCount {
  readonly item = input.required<Pick<NavItem, 'count' | 'countTone' | 'countStyle' | 'countLabel'>>();
}
